import { render, staticRenderFns } from "./OpeningsInput.vue?vue&type=template&id=3ecc12b4&scoped=true&"
import script from "./OpeningsInput.vue?vue&type=script&lang=js&"
export * from "./OpeningsInput.vue?vue&type=script&lang=js&"
import style0 from "./OpeningsInput.vue?vue&type=style&index=0&id=3ecc12b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecc12b4",
  null
  
)

export default component.exports